export const languageData = [
    { code: 'en-US', value: 'EN', label: 'English' },
    { code: 'sv-SE', value: 'SE', label: 'Svenska' },
    { code: 'nb-NO', value: 'NO', label: 'Norsk' },
]

export const loginTypes = [
    { label: 'BankID Sweden', value: 'bankid-se' },
    { label: 'BankID Norway', value: 'bankid-no' },
    { label: 'BankID Finland', value: 'bankid-fi' },
    { label: 'EIDs Denmark', value: 'mitid-dk' },
    { label: 'Estonian ID eID Easy', value: 'ee-id' },
    { label: 'Latvian ID eID Easy', value: 'lv-id' },
    { label: 'Lithuanian ID eID Easy', value: 'lt-id' },
]

export const ssnPlaceholders = {
    'bankid-no': 'YYYYMMDDXXX',
    'ee-id': 'SSN 11 digits',
    'lv-id': 'SSN 11 digits with dash',
    'lt-id': 'SSN 11 digits',
}

export const ssnRequiredLoginTypes = ['bankid-no', 'ee-id', 'lt-id', 'lv-id']

export const DASHBOARD_REFRESH_TIME = 10000
